import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";


//1) GET MUTUAL FRIENDS LIST
export const getMutualFriendsList = createAsyncThunk(
    "getMutualFriendsList", async (userId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/mutual-friends/${userId}/`);
            const result = response.data;
            return result;
        } catch (error) {
            console.error("Error fetching mutual friends:", error);
            return rejectWithValue(error.response.data);
        }
    }
);


export const MutualFriendsSlice = createSlice({
    name: "MutualFriends",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        //  action promises
        builder.addCase(getMutualFriendsList.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getMutualFriendsList.fulfilled, (state, action) => {
            state.data = action?.payload?.mutual_friends;
            state.loading = false;
        });
        builder.addCase(getMutualFriendsList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default MutualFriendsSlice.reducer;
